import Button from 'components/ReusableComponents/Button'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from '../MultiStepPMSLogin.module.scss'

const PendingEmailConfirmation = ({ setUpdateConfig }) => {
  const { addToast } = useToasts()

  const handleClick = e => {
    e.preventDefault()

    pmsApi
      .ohipEmailCheck()
      .then(res =>
        addToast(res, {
          appearance: 'success',
          autoDismiss: true
        })
      )
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setUpdateConfig(prev => prev + 1)
      })
  }

  return (
    <div className={styles.stepActions}>
      <div className={styles.actionContainer}>
        <div>
          <p className={styles.cardTitle}>
            Pending approval from Hotel Opera Administrator
          </p>
          <p className={styles.cardBasicText}>
            Directful’s user access request for the Opera platform is pending approval. We
            are currently waiting for the hotel’s Opera Administrator to approve this
            request.
          </p>

          <p className={styles.cardBasicText}>
            <span className={styles.cardTitle}>Action Required: </span> Identify the Opera
            Administrator: This is the person who provided you with the login URL, HubID,
            and PropertyID. If you are not aware of who this is, please contact your
            counterpart at the hotel to find out.
          </p>

          <p className={styles.cardBasicText}>
            <span className={styles.cardTitle}>Approval Follow-Up: </span> Once you know
            the Opera Administrator, follow up with them to ensure they approve the
            request.
          </p>

          <p className={styles.cardBasicText}>
            <span className={styles.cardTitle}>Next Steps: </span> After the approval, an
            email will be automatically sent to proceed with the integration. If you
            believe the approval has already been provided, click the button below to
            check the status again. Please note, this process may take some time.
          </p>

          <div className={styles.checkButton}>
            <Button type="secondary" size="regular" onClick={handleClick}>
              <span className={styles.secondaryButtonTitle}>Check manually</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PendingEmailConfirmation
